import Axios from "axios";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

// REACT_APP_API_BASE_URL is set at build time for environments without an
// entry below (e.g. dev2, which builds as "test" but has its own API host).
Axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : process.env.REACT_APP_NAKAD_LOCAL
  ? null
  : process.env.REACT_APP_NAKAD_ENV === "test"
  ? "https://api.dev.nakad.co/dtf"
  : process.env.REACT_APP_NAKAD_ENV === "staging"
  ? `https://api.staging.nakad.co/dtf/`
  : process.env.REACT_APP_NAKAD_ENV === "preprod"
  ? `https://api.preprod.nakad.co/dtf/`
  : process.env.REACT_APP_NAKAD_ENV === "production"
  ? `https://api.preprod.nakad.co/dtf/`
  : null;
Axios.defaults.withCredentials = true;
// Axios.defaults.baseURL = "http://localhost:8082/dtf";
ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
